import React from 'react';
import { Modal, Form, Input, Select, InputNumber, DatePicker, Checkbox } from 'antd';
import { METER_STATUS, METER_STATUS_LABELS } from '../../models/types';
import dayjs from 'dayjs';

const MeterForm = ({ visible, onClose, onSubmit, initialValues, subscribers }) => {
  const [form] = Form.useForm();

  React.useEffect(() => {
    if (initialValues) {
      form.setFieldsValue({
        ...initialValues,
        calibrationDate: dayjs(initialValues.calibrationDate),
        installationDate: dayjs(initialValues.installationDate)
      });
    } else {
      form.resetFields();
    }
  }, [initialValues, visible, form]);

  const handleSubmit = async (values) => {
    try {
      await form.validateFields();
      const submitData = {
        ...values,
        calibrationDate: values.calibrationDate.toISOString(),
        installationDate: values.installationDate.toISOString()
      };
      onSubmit(submitData);
      form.resetFields();
    } catch (error) {
      console.error('Form validation failed:', error);
    }
  };

  return (
    <Modal
      title={initialValues ? 'Modifier un compteur' : 'Ajouter un compteur'}
      open={visible}
      onOk={() => handleSubmit(form.getFieldsValue())}
      onCancel={onClose}
      width={600}
      okText="Enregistrer"
      cancelText="Annuler"
    >
      <Form
        form={form}
        layout="vertical"
        initialValues={{
          status: METER_STATUS.ACTIVE,
          capacity: 1000,
          lifespan: 10
        }}
      >
        <Form.Item
          label="Numéro de série"
          name="serialNumber"
          rules={[{ required: true, message: 'Le numéro de série est obligatoire' }]}
        >
          <Input placeholder="Entrer le numéro de série" />
        </Form.Item>

        <Form.Item
          label="Marque"
          name="brand"
          rules={[{ required: true, message: 'La marque est obligatoire' }]}
        >
          <Input placeholder="Marque du compteur" />
        </Form.Item>

        <Form.Item
          label="Modèle"
          name="model"
          rules={[{ required: true, message: 'Le modèle est obligatoire' }]}
        >
          <Input placeholder="Modèle du compteur" />
        </Form.Item>

        <Form.Item
          label="Capacité (m³)"
          name="capacity"
          rules={[{ required: true, message: 'La capacité est obligatoire' }]}
        >
          <InputNumber min={1} step={100} style={{ width: '100%' }} />
        </Form.Item>

        <Form.Item
          label="Abonné"
          name="subscriberId"
          rules={[{ required: true, message: "L'abonné est obligatoire" }]}
        >
          <Select
            placeholder="Sélectionner un abonné"
            options={subscribers.map(s => ({
              label: `${s.firstName} ${s.lastName}`,
              value: s.id
            }))}
            filterOption={(input, option) =>
              option.label.toLowerCase().includes(input.toLowerCase())
            }
            showSearch
          />
        </Form.Item>

        <Form.Item
          label="Date de calibrage"
          name="calibrationDate"
          rules={[{ required: true, message: 'La date de calibrage est obligatoire' }]}
        >
          <DatePicker style={{ width: '100%' }} locale={{ lang: { locale: 'fr' } }} />
        </Form.Item>

        <Form.Item
          label="Date d'installation"
          name="installationDate"
          rules={[{ required: true, message: "La date d'installation est obligatoire" }]}
        >
          <DatePicker style={{ width: '100%' }} />
        </Form.Item>

        <Form.Item
          label="Durée de vie (années)"
          name="lifespan"
          rules={[{ required: true, message: 'La durée de vie est obligatoire' }]}
        >
          <InputNumber min={1} style={{ width: '100%' }} />
        </Form.Item>

        <Form.Item
          label="Lecture initiale"
          name="initialReading"
          rules={[{ required: true, message: 'La lecture initiale est obligatoire' }]}
        >
          <InputNumber min={0} style={{ width: '100%' }} />
        </Form.Item>

        <Form.Item
          label="Statut"
          name="status"
        >
          <Select
            options={Object.entries(METER_STATUS).map(([key, value]) => ({
              label: METER_STATUS_LABELS[value],
              value: value
            }))}
          />
        </Form.Item>

        <Form.Item
          label="Alerte anomalie"
          name="anomalyAlert"
          valuePropName="checked"
        >
          <Checkbox>Ce compteur présente une consommation anormale</Checkbox>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default MeterForm;
